import type { FormComponent, FormDSL } from '@commenda/types';
import { walkComponents } from '../dsl-traversal';

export interface BusinessEntitySelectOrCreateData {
  fieldId: string;
  selectedEntityIds: string[];
  template: FormComponent[];
}

/**
 * BusinessEntitySelectOrCreate components need special handling because they
 * have required fields (legalName, incorporationCountry, jurisdiction,
 * businessEntityType) plus extra template fields. The extractor seeds the
 * template; `selectedEntityIds` is populated from formData later by the
 * integration hook.
 */
export function extractBusinessEntitySelectOrCreateComponents(
  dsl: FormDSL
): BusinessEntitySelectOrCreateData[] {
  const components: BusinessEntitySelectOrCreateData[] = [];
  walkComponents(dsl, (component) => {
    if (
      component.component === 'BusinessEntitySelectOrCreate' &&
      component.fieldId
    ) {
      components.push({
        fieldId: component.fieldId,
        selectedEntityIds: [], // populated from formData
        template: component.template || [],
      });
    }
  });
  return components;
}
